package dev.lingvo.site.pages.app.settings

import androidx.compose.runtime.Composable
import dev.lingvo.shared.Plan
import dev.lingvo.shared.Role
import dev.lingvo.shared.seatCapReason
import dev.lingvo.site.ds.LAlert
import dev.lingvo.site.ds.LAlertVariant
import dev.lingvo.site.ds.LLinkButton
import dev.lingvo.site.ds.LButtonVariant
import dev.lingvo.site.i18n.t

/** A seat limit leaves the free invitation option available and names who can change capacity. */
@Composable
internal fun SeatLimitNotice(plan: Plan, role: Role?) {
    LAlert(
        title = t("app.settings.seat_limit_notice.admin_seats_are_full_on_this", "Admin seats are full on this plan"),
        description = seatCapReason(plan) + " " + if (role == Role.OWNER) {
            t("app.settings.seat_limit_notice.to_add_an_admin_review_plans", "To add an admin, review plans in Billing.")
        } else {
            t("app.settings.seat_limit_notice.to_add_an_admin_ask_a", "To add an admin, ask a workspace owner to review plans in Billing.")
        },
        variant = LAlertVariant.INFO,
        action = if (role == Role.OWNER) {
            { LLinkButton(label = t("app.settings.seat_limit_notice.review_plans", "Review plans"), path = "/app/settings/billing/plans", variant = LButtonVariant.SECONDARY) }
        } else null,
    )
}
